"use strict"
import axios from "axios"
import qs from "qs"
import bus from "./bus.js"
import { removeTokenInfo, removeUserInfo, removeMenu, removeExpire, getTokenInfo } from "../utils/auth"
const _login = '/workorder'

//处理请求数据 不判断token令牌白名单
const whiteList = ["/token", "/search"]
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'
axios.interceptors.request.use(
  config => {
    // 请求拦截
    const isToken = (config.headers || {}).isToken === false
    let _tokeninfo = getTokenInfo()
    let token = _tokeninfo ? _tokeninfo.token : ""
    if (token && !isToken) {
      config.headers["Authorization"] = _tokeninfo.token_type + " " + token
    }
    if (config.method == 'post' || config.method == 'POST') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    //响应拦截
    return response;
  },
  error => {
    return Promise.resolve(error.response);
  }
);

function getData(val, url) {
  // 判断登录用户信息/权限
  if (whiteList.join(",").indexOf(url) >= 0) {
    // 密码登录：登录    手机登录：获取验证码、登录
    return val
  } else {
    const _tokeninfo = getTokenInfo()
    const token = _tokeninfo ? _tokeninfo.token : ""
    if (!token) {
      window.location.href = _login
    }
    if (typeof val == "string") {
      return JSON.parse(val)
    } else {
      return val
    }
  }
}
// function transformRequest(data) {
//   let ret = ''
//   for (let it in data) {
//     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
//   }
//   return ret
// }
// 请求参数
function getOptions(url, method, data) {
  const options = {
    method: method,
    baseURL: window.g.API_ROOT,
    url: url,
    timeout: window.g.AXIOS_TIMEOUT ? window.g.AXIOS_TIMEOUT : 10000,
    headers: {}
  }
  if (data.header) {
    options.headers[data.header.type] = data.header.role
  }
  if (data.body) {
    options["data"] = getData(data.body, url);
  }
  if (data.query) {
    options['params'] = getData(data.query, url)
  }

  return options;
}

function checkStatus(response) {
  //处理响应数据
  if (response && response.status === 200) {
    // loading,如果http状态码正常，则直接返回数据
    let res = response.data;
    if (!res) {
      bus.$message.error("服务器开了个小差");
      return false;
    }
    if (res.status == 0) {
      // bus.$message.error(res.message);
      return res;
    } else {
      if (res.msg) {
        bus.$message.error(res.msg);
      }
      return false;
    }
  } else if (response && response.status === 401) {
    removeTokenInfo() // 移除token信息
    removeUserInfo() //移除用户信息
    removeMenu()
    removeExpire()
    window.location.href = _login
    return false;
  } else {
    if (response.data.msg) {
      bus.$message.error(response.data.msg);
    }
    return false;
  }
}

function checkCode(error) {
  bus.$message.error("网络异常~");
}

/**
 * 请求传参
  url:''
  data:{
    header:{
      type:'',
      role:''
    },
    body:{
    },
    query:{
    }
  }
 *  */
export default {
  async post(url, data) {
    const options = getOptions(url, "post", data)
    return axios(options)
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      })
  },
  postres(url, data) {
    const options = getOptions(url, "post", data);
    return axios(options)
      .then(response => {
        return response
      })
      .catch(res => {
        return checkCode(res);
      })
  },
  getres(url, data) {
    const options = getOptions(url, "get", data);
    return axios(options)
      .then(response => {
        return response
      })
      .catch(res => {
        return checkCode(res);
      })
  },
  get(url, data) {
    const options = getOptions(url, "get", data);
    return axios(options)
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      })
  },
  put(url, data) {
    const options = getOptions(url, "put", data);
    return axios(options)
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      })
  },
  delete(url, data) {
    const options = getOptions(url, "delete", data);
    return axios(options)
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      })
  }
}



// WEBPACK FOOTER //
// ./src/modules/workorder/api/http.js